import { map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AjaxData, AjaxService } from '../../core/ajax.service';
import { ApiRoutesV1 } from '../../common/routes';

@Injectable()
export class ReviewPageUrlsService {
  constructor(private readonly ajaxService: AjaxService) {}

  getMyListingUrl(): Observable<string> {
    return this.ajaxService.get(ApiRoutesV1.reviewUrlMyListing).pipe(
      map((response: HttpResponse<AjaxData>) => {
        return response.body.data.myListingUrl;
      }),
    );
  }

  hasMyListing(): Observable<boolean> {
    return this.getMyListingUrl().pipe(map((url: string) => url !== null));
  }
}

export interface CustomerDrivenReviewGenSettings {
  customerDrivenReviewGenUrl: string;
  customerDrivenReviewGenFeatureFlag: boolean;
}
